import { client } from './client';
import type { CreateAssignmentInput } from '@/types/assignment';

export async function createAssignment(input: CreateAssignmentInput): Promise<void> {
  await client.post('/api/v1/assignments', input);
}

export async function completeAssignment(id: string): Promise<void> {
  await client.put(`/api/v1/assignments/${id}/complete`);
}
